import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  constructor(private httpClient: HttpClient) {}
  private headerStyle: BehaviorSubject<string> = new BehaviorSubject<string>('header-transparent');
  private pageStyle: BehaviorSubject<string> = new BehaviorSubject<string>('header-transparent');
  private circleOnPage: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private hotelOpenGeo: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private routeOpenMap: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private thisHotel: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private hideMobHeader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  getActiveInterface() {
    return this.headerStyle.value;
  }
  setActiveInterface(value: string) {
    this.headerStyle.next(value);
  }

  getPageInterface() {
    return this.pageStyle.value;
  }
  setPageInterface(value: string) {
    this.pageStyle.next(value);
    this.setActiveInterface(value);
  }

  setHeaderStyle(value: boolean) {
    this.circleOnPage.next(value);
  }

  getHeaderStyle() {
    return this.circleOnPage.value;
  }

  setHotelOpenGeo(value: boolean) {
    this.hotelOpenGeo.next(value);
  }

  getHotelOpenGeo() {
    return this.hotelOpenGeo.value;
  }

  setRouteOpenMap(value: boolean) {
    this.routeOpenMap.next(value);
  }

  getRouteOpenMap() {
    return this.routeOpenMap.value;
  }

  setThisHotel(value: boolean) {
    this.thisHotel.next(value);
  }

  getThisHotel() {
    return this.thisHotel.value;
  }
}
